import { RECOLLECTION_STEP_PATHS } from '@/constants';
import Introduction from '@/containers/recollection/Introduction';
import Confirmation from '@/containers/recollection/Confirmation';
import Overview from '@/containers/recollection/Overview';
import { not } from '@/flow/common';

import { getDefaultRoleConstraints } from '../selectors';
import { canShowSummaryRecollection, isSubmitted } from '../selectors/recollection';

export default ({ StakeholderBlock }) => {
  const stakeholderBlock = new StakeholderBlock();

  return {
    stepNotFoundPath: RECOLLECTION_STEP_PATHS.CONFIRMATION_PATH,
    globalPrerequisites: [
      { prerequisite: not('isSubmitted'), back: RECOLLECTION_STEP_PATHS.OVERVIEW_PATH },
    ],
    selectors: {
      defaultRoleConstraints: getDefaultRoleConstraints,
      canShowSummaryRecollection,
      isSubmitted,
      ...stakeholderBlock.getSelectors(),
    },
    neededCaps: {},
    steps: [
      {
        id: 'introduction',
        path: RECOLLECTION_STEP_PATHS.INTRODUCTION_PATH,
        Container: Introduction,
        back: false,
        next: stakeholderBlock.generateNextForPreviousStep(),
      },
      ...stakeholderBlock.generateFlowConfig({
        back: RECOLLECTION_STEP_PATHS.INTRODUCTION_PATH,
        next: RECOLLECTION_STEP_PATHS.CONFIRMATION_PATH,
      }),
      {
        id: 'confirmation',
        path: RECOLLECTION_STEP_PATHS.CONFIRMATION_PATH,
        prerequisite: 'canShowSummaryRecollection',
        Container: Confirmation,
        back: stakeholderBlock.generateBackForNextStep(),
        next: RECOLLECTION_STEP_PATHS.OVERVIEW_PATH,
      },
      {
        id: 'overview',
        path: RECOLLECTION_STEP_PATHS.OVERVIEW_PATH,
        prerequisite: 'isSubmitted',
        Container: Overview,
        back: RECOLLECTION_STEP_PATHS.CONFIRMATION_PATH,
        next: false,
      },
    ],
  };
};
